import { render, staticRenderFns } from "./WingsAdd.vue?vue&type=template&id=5456b52a&"
import script from "./WingsAdd.vue?vue&type=script&lang=js&"
export * from "./WingsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports